export default __webpack_public_path__ + "static/media/sneakerCard.41bd6840.png";